import useSticky from 'app/hooks/useSticky'
import { cloneElement, FC, ReactElement, RefObject, useEffect } from 'react'

interface StepperFeatStickyComponentProps {
  stickyComponentRef?: RefObject<HTMLElement>
  children: ReactElement
  isStickyCallback?: (isSticky: boolean) => void
}

/**
 * This component decides how to render steps and buttons depending on whether the stickyComponentRef element is sticky or not.
 * @param {RefObject<HTMLElement>} props.stickyComponentRef - The ref for the sticky component.
 * @param {Function} props.isStickyCallback - Callback function to notify when the sticky state changes.
 * @param {ReactElement} props.children - The children Stepper component to be rendered.
 * @returns {ReactElement} The rendered component.
 */
export const StepperFeatStickyComponentController: FC<StepperFeatStickyComponentProps> =
  ({ stickyComponentRef, children, isStickyCallback }) => {
    const { isSticky, scrollParent } = useSticky(stickyComponentRef ?? null)

    const updatedChildren = cloneElement(children, {
      renderDropdown: isSticky,
      ButtonsElement: children.props?.ButtonsElement
        ? cloneElement(children.props?.ButtonsElement, {
          shrink: children.props?.ButtonsElement?.props?.shrink || isSticky
        })
        : null
    })

    useEffect(() => {
      if (isStickyCallback !== undefined) {
        isStickyCallback(isSticky)
      }
    }, [isSticky])

    return (
      <>
        {updatedChildren}
      </>
    )
  }
